import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SInput from 'SharedComponents/ui/Input/SInput.vue';
import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';

interface Props extends PropValue<string | null> {
  textarea: boolean;
  description?: string;
}

export default /*@__PURE__*/_defineComponent({
  ...{ name: 'TextParameter' },
  __name: 'Text',
  props: {
    textarea: { type: Boolean },
    description: { default: '' },
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emit = __emit;
const { innerValue, emitValue } = useValue(props, emit);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SInput, _mergeProps({
    modelValue: _unref(innerValue),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(innerValue) ? (innerValue).value = $event : null))
  }, _ctx.$attrs, {
    clearable: "",
    outlined: "",
    dense: "",
    "hide-bottom-space": "",
    type: _ctx.textarea ? 'textarea' : 'text',
    autogrow: "",
    "onUpdate:modelValue": _unref(emitValue)
  }), null, 16, ["modelValue", "type", "onUpdate:modelValue"]))
}
}

})